import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'
import '@fontsource-variable/inter'
import '@fontsource-variable/outfit'

const defaultFont = `system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`

const customConfig = defineConfig({
  theme: {
    tokens: {
      fonts: {
        heading: { value: `'Outfit Variable', ${defaultFont}` },
        body: { value: `'Inter Variable', ${defaultFont}` },
      },
    },
  },
})

export const system = createSystem(defaultConfig, customConfig)
